import KendoRangeSliderMixin from './KendoRangeSliderMixin'

export default {
    name: 'kendo-rangeslider',
    mixins: [ KendoRangeSliderMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoRangeSlider/index.js